<template>
    <div class="">
      <v-flex hidden-md-and-down>
      <public-main-slider></public-main-slider>
      </v-flex>
      <v-flex hidden-lg-and-up>
        <search></search>
      </v-flex>
      <br>
      <v-container fluid>
        <v-toolbar color="#74a533" tabs flat>
          <v-tabs
            centered
            color="#74a533"
            slot="extension"
            slider-color="white"
            style="text-decoration: none; font-family: 'Arial Black'; color: #0a0a0a"
            v-model="model"
            flat
          >
            <v-tab
              :key="1"
            >
              Activities
            </v-tab>
            <v-tab
              :key="2"
            >
              Accommodation
            </v-tab>
            <v-tab
              :key="3"
            >
              Camping
            </v-tab>
          </v-tabs>
        </v-toolbar>
        <v-tabs-items v-model="model">
          <v-tab-item
            :key="1"
          >
              <activities></activities>
          </v-tab-item>
          <v-tab-item
            :key="2"
          >
              <accomodations></accomodations>
          </v-tab-item>
          <v-tab-item
            :key="3"
          >
              <camp-sites></camp-sites>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </div>
</template>

<script>
import PublicMainSlider from '../Repeated/Slider'
import Accomodations from '../Repeated/Accomodation'
import CampSites from '../Repeated/CampSites'
import Activities from '../Repeated/Activities'
import Search from '../Repeated/Search'
export default {
  data () {
    return {
      model: null
    }
  },
  components: {
    Search,
    Activities,
    CampSites,
    Accomodations,
    PublicMainSlider },
  name: 'index',
  created () {
    localStorage.setItem('user_data', JSON.stringify({
      currency: 'KES',
      type: 'GB601X10',
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      destination: '',
      check_in: '',
      check_out: '',
      session_id: 'Guest'
    }))
    localStorage.setItem('vehicle_data', JSON.stringify([]))
    localStorage.setItem('conservation_data', JSON.stringify([]))
    localStorage.setItem('facility_data', JSON.stringify([]))
    localStorage.setItem('activity_data', JSON.stringify([]))
  
  },
  sockets: {
    connect: function (myEvent) {
    },
    mpesa: function (data) {
    },
    customEmit: function (val) {
      console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
    }
  },
  methods: {
    next () {
      const active = parseInt(this.active)
      this.active = (active < 2 ? active + 1 : 0).toString()
    }
  }
}
</script>

<style scoped>
 a {
   text-decoration: none;
 }
 .knockout-color {
   font-family: Knockout;
   color: #0a0a0a;
 }
</style>
